import React from "react";
import { useParams } from "react-router";
import Query from "../component/Query/index";
import ReactMarkdown from "react-markdown";
import Moment from "react-moment";
import ARTICLE_QUERY from "../queries/articles/article";
import Footer from "../component/Footer";

const Article = () => {
  let { slug } = useParams();

  return (
    <div>
      <Query query={ARTICLE_QUERY} slug={slug}>
        {({ data: { articles } }) => {
          if (articles.length) {
            const imageUrl = articles[0].image.url;

            return (
              <div className="pt-24 xl:pt-48 lg:mx-32 mx-2 font-poppins">
                <p className="text-right text-gray-600 ">
                  Posted&nbsp;
                  <Moment format="MMM Do YYYY">{articles[0].published}</Moment>
                </p>

                <div
                  id="banner"
                  className="flex flex-col justify-center items-center mt-6 xl:mt-12"
                  data-src={imageUrl}
                  data-srcset={imageUrl}
                  data-uk-img
                >
                  <h1 className="text-4xl font-bold my-3 text-center">
                    {articles[0].title}
                  </h1>
                  <h2 className="text-center text-main-color my-3">
                    {articles[0].description}
                  </h2>
                  <div className="flex mb-10">
                    {articles[0].categories.map((category) => (
                      <p className="text-xs md:text-base  mx-1 lg:mx-2 my-3 p-2 bg-gray-100 ">
                        {category.name}
                      </p>
                    ))}
                  </div>
                  <aside className="hidden xl:block">
                    <div class="sidebar-left absolute right-12 top-100 mt-11 flex flex-col">
                      <a
                        className="border rounded-full border-gray-800 bg-white flex h-12 w-12 items-center justify-center my-1"
                        href="#"
                        title="Facebook"
                        aria-label="Facebook"
                        target="_blank"
                      >
                        <img src="../img/fb2.svg" alt="" />
                      </a>
                      <a
                        className="border rounded-full border-gray-800 bg-white flex h-12 w-12 items-center justify-center my-1"
                        href="#"
                        title="Twitter"
                        aria-label="Twitter"
                        target="_blank"
                      >
                        <img src="../img/twitter.svg" alt="" />
                      </a>
                      <a
                        className="border rounded-full border-gray-800 bg-white flex h-12 w-12 items-center justify-center my-1"
                        href="#"
                        title="Google"
                        aria-label="Google"
                        target="_blank"
                      >
                        <img src="../img/google.svg" alt="" />
                      </a>
                      <a
                        className="border rounded-full border-gray-800 bg-white flex h-12 w-12 items-center justify-center my-1"
                        href="#"
                        title="Linkedin"
                        aria-label="Linkedin"
                        target="_blank"
                      >
                        <img
                          src="../img/linkedin2.png"
                          className="text-gray-600"
                          width="24"
                          alt=""
                        />
                      </a>
                    </div>
                  </aside>
                  <img src={imageUrl} width="1200" alt="" />
                </div>

                <div>
                  <div className="lg:px-24 mt-12">
                    <ReactMarkdown
                      className="prose"
                      children={articles[0].content}
                      escapeHtml={true}
                    />
                  </div>
                </div>
              </div>
            );
          }
        }}
      </Query>
      <Footer />
    </div>
  );
};

export default Article;
